module.exports = __webpack_public_path__ + "static/NeuzeitSLTStd-BookHeavy-553e24a81307f6b70d042a2c34ef35c1.woff";